import React from "react";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { formatTenantType } from "../../../utils/tenantTypeFormatter";
import { getCountryISO2From3CharCode } from "~/utils/countries";

const TenantSidebar = ({
  tenant,
  activeSection,
  onSectionChange,
  onNavigateBack,
}) => {
  const getTenantInitials = (name) => {
    if (!name) return "T";
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const formatStatus = (status) => {
    if (!status) return "Active";
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  return (
    <div className="core-tenant-info__left-column">
      {/* Header with back button */}
      <div className="core-tenant-info__header">
        <button
          className="core-tenant-info__back-btn"
          onClick={onNavigateBack}
          title="Go back"
        >
          <i className="pi pi-arrow-left"></i>
        </button>
        <h2 className="core-tenant-info__title">Core Tenant Information</h2>
      </div>

      {/* Sidebar */}
      <div className="core-tenant-info__sidebar">
        <div className="core-tenant-info__sidebar-header">
          <div className="core-tenant-info__tenant-avatar">
            {getTenantInitials(tenant.tenant_name)}
          </div>
          <div className="core-tenant-info__tenant-info">
            <h3 className="core-tenant-info__tenant-name">
              {tenant.tenant_name}
            </h3>
            {tenant.type && (
              <p className="core-tenant-info__tenant-type">
                {formatTenantType(tenant.type)}
              </p>
            )}
            {tenant.country && (
              <div className="core-tenant-info__tenant-country">
                <ReactCountryFlag
                  countryCode={
                    tenant.country.length === 3
                      ? getCountryISO2From3CharCode(tenant.country)
                      : tenant.country
                  }
                  svg
                  style={{ width: "16px", height: "16px" }}
                />
                <span>
                  {getName(
                    tenant.country.length === 3
                      ? getCountryISO2From3CharCode(tenant.country)
                      : tenant.country,
                  )}
                </span>
              </div>
            )}
            {tenant.status && (
              <span
                className={`core-tenant-info__status-badge core-tenant-info__status-badge--${tenant.status.toLowerCase()}`}
              >
                {formatStatus(tenant.status)}
              </span>
            )}
          </div>
        </div>

        {/* Sidebar Menu */}
        <nav className="core-tenant-info__sidebar-menu">
          <button
            className={`core-tenant-info__menu-item ${
              activeSection === "info" ? "active" : ""
            }`}
            onClick={() => onSectionChange("info")}
          >
            <span>General Information</span>
            <i className="pi pi-chevron-right"></i>
          </button>
          {tenant?.type === "LSP" && (
            <button
              className={`core-tenant-info__menu-item ${
                activeSection === "customer-portfolio" ? "active" : ""
              }`}
              onClick={() => onSectionChange("customer-portfolio")}
            >
              <span>Customer Portfolio</span>
              <i className="pi pi-chevron-right"></i>
            </button>
          )}
          <button
            className={`core-tenant-info__menu-item ${
              activeSection === "assigned-users" ? "active" : ""
            }`}
            onClick={() => onSectionChange("assigned-users")}
          >
            <span>Assigned Users</span>
            <i className="pi pi-chevron-right"></i>
          </button>
          <button
            className={`core-tenant-info__menu-item ${
              activeSection === "admin-info" ? "active" : ""
            }`}
            onClick={() => onSectionChange("admin-info")}
          >
            <span>Admin Information</span>
            <i className="pi pi-chevron-right"></i>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default TenantSidebar;
